import { useState, useEffect } from "react";
import { TextField, Grid, Button, Typography, MenuItem, Select, Box, Tooltip } from "@mui/material"
import { useFormik } from 'formik';
import * as yup from 'yup';
import Backdrop from '../components/backdrop-component';
import SubscriptionPage from './subscription-page';
import Timer from "../components/timer";
import supporticon from '../assets/Images/supporticon.png'
import jodoWorld from '../assets/Images/jodoWorld.png'
import { useDispatch, useSelector } from "react-redux";
import getLanguageDetails from "jodo-language-package"
import {
    setemailAddress,
    authenticateEmailId,
    setexternalAuthUserData,
    uploadImageAPI,
    setopenLoader,
    setsnackBar,
    setLanguage,
    verifyOTP,
    resendOTP,
    setstartTimer,
    setresendButtonDisable,
    setInitailLag,
    setlanguage_email,
    setMultilingual,
    userApiTokenGenerate
} from "../reducers/global-reducer";
import { Google, LinkedIn } from "@mui/icons-material";
import { useLocation, useParams } from "react-router-dom";
import { useTranslate, IntlActions } from "react-redux-multilingual";
import DisplayMessage from "../components/display-message-component";
import ReactGA from "react-ga4";
import "./email-authentication-page.css"
import DOMPurify from "dompurify";
import { logGAEvent } from "../components/util/util";



const Confdata = window['runConfig']
const EmailAuthentication = () => {
    const [moveToSubscriptionPage, setmoveToSubscriptionPage] = useState(false);
    const [showOtpField, setshowOtpField] = useState(false);
    const [redirectingPage, setredirectingPage] = useState(false);
    // const { serviceID, lang } = useParams()
    const { serviceID } = useParams();
    // Prepend '?' to make it a valid query string
    const searchParams = new URLSearchParams("?" + serviceID);
    const lang = searchParams.get("lang");

    const dispatch = useDispatch();
    const store = useSelector(state => state);
    const {
        showOTPmsgLabel,
        newEmailVerified,
        initailLag,
        language,
        otpResend,
        isOTPValid,
        openLoader,
        emailAddress,
    } = store.globalreducer;
    const languageObj = getLanguageDetails("langarr")
    const t = useTranslate();
    const { snackBar } = store.globalreducer;

    useEffect(() => {
        dispatch(setMultilingual(t))
    })
    // styles
    const style = {
        headcontainer: {
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center'
        },
        box: {
            textAlign: "center",
            borderColor: "white"
        },
        head: { width: '370px' },
        email: { width: '16rem', border: 'none !important', marginTop: `${newEmailVerified === 1 ? "4rem" : '0px'}` },
        otp: { width: '16rem', border: 'none !important', margin: '10px 0' }
    }


    // Get language from url and set to state 
    useEffect(() => {
        // get language from localstorage and set to the language state
        if (localStorage.getItem("language")) {
            dispatch(IntlActions.setLocale(localStorage.getItem("language")))
            dispatch(setLanguage(localStorage.getItem("language")))
            dispatch(setInitailLag(localStorage.getItem("language")))
        }
        else if (lang) {
            localStorage.setItem("language", lang)
            dispatch(setLanguage(lang))
            dispatch(IntlActions.setLocale(lang))
            dispatch(setInitailLag(lang))
        } else {
            localStorage.setItem("language", "en")
        }


    }, [lang])


    //  *** validation  for email ***
    let validationSchemaOne = yup.object({
        email: yup
            .string(t('enterEmail'))
            .email(t('emailRegexValidation'))
            .required(t('emailRequiredValidation'))
            .min(5, t('emailMinValidation'))
            .max(100, t('emailMaxValidation')),
    });
    //*** ***

    let otpValidation = yup.object({
        email: yup
            .string(t('enterEmail'))
            .email(t('emailRegexValidation'))
            .required(t('emailRequiredValidation'))
            .min(5, t('emailMinValidation'))
            .max(100, t('emailMaxValidation')),
        otp: yup
            .string(t('enterotp'))
            .required(t('otpRequiredValidation'))
            .matches(/^[0-9]+$/, t('otpValidationRegex'))
            .max(10, t('otpMaxLengthValidation'))
    })

    // When StripeEmailServlet call  the it will execute 
    useEffect(() => {
        if (newEmailVerified) {
            if (newEmailVerified === 1) {
                setshowOtpField(true);
                dispatch(setstartTimer(true));
                setTimeout(() => {
                    dispatch(setresendButtonDisable(false))
                }, 31000);
            }
            else if (newEmailVerified === 103) {
                return setredirectingPage(true);

                //*********DO NOT DELETE BELOW CODE**************
                //***** FUNCTION FOR REDIRECTING TO JODO WORLD SIGN ON *****

                function base64EncodeUnicode(str) {
                    let utf8Bytes = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
                        return String.fromCharCode('0x' + p1);
                    })
                    return window.btoa(utf8Bytes)
                }
            }
        }
    }, [newEmailVerified])

    useEffect(() => { // USE: AFTER OTP IS VERIFIED, IF THE isOTPValid === 1 THEN THE FUNCTION WILL BE INVOKED
        if (isOTPValid === 1) {
            logGAEvent("User Interaction", "verify_OTP", isOTPValid, emailAddress);

            setmoveToSubscriptionPage(true)
            handleClose()
        }
    }, [isOTPValid])

    useEffect(() => { // USE: AFTER RESEND OTP BUTTON IS CLICKED, IF THE otpResend === 1 THEN THE FUNCTION WILL BE INVOKED
        if (otpResend === 1) {
            logGAEvent("User Interaction", "resend_OTP", otpResend, emailAddress);

            setTimeout(() => {
                dispatch(setresendButtonDisable(false))
            }, 31000);
        }
    }, [otpResend])

    useEffect(() => {
        let authResponse = window.location.href.split("authresponse=")[1]
        if (authResponse) {
            const response = JSON.parse(window.atob(authResponse.replace("#", "")))
            if (response.isuserexists) {
                dispatch(setemailAddress(response.email))
                return setredirectingPage(true)
            }
            if (response.status !== 1) {
                window.location.href = `${Confdata.apiUrl}/jodostripe/subscription/${serviceID}`
            }
            const getBase64FromUrl = async (url) => {
                const data = await fetch(url);
                const blob = await data.blob();
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                        const base64data = reader.result;
                        resolve(base64data);
                    }
                });
            }

            let profilePic = response.profileimage
            getBase64FromUrl(profilePic).then(res => {
                let ImageBase64 = res.substring(23)
                dispatch(uploadImageAPI({
                    filename: 'user_profilepic_' + new Date() + '.jpeg',
                    filedata: ImageBase64
                }))
            })
            getBase64FromUrl(profilePic)
                .then(res => {
                    let ImageBase64 = res.substring(23);
                    dispatch(uploadImageAPI({
                        filename: 'user_profilepic_' + new Date() + '.jpeg',
                        filedata: ImageBase64
                    }));
                })
                .catch(error => {
                    // Handle error here
                    console.error('Error fetching base64 data:', error);
                });
            dispatch(setexternalAuthUserData(response))
            setmoveToSubscriptionPage(true)
        }
    }, [])
    // this useeffect get initial language from local storage 


    const handleClose = () => {
        dispatch(setopenLoader(false))
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            otp: ''
        },
        validationSchema: newEmailVerified === 1 ? otpValidation : validationSchemaOne,

        onSubmit: (values) => {
            // indicate new user 
            if (newEmailVerified === 1) {
                dispatch(setopenLoader(true))
                logGAEvent("User Interaction", "verify_OTP", values.otp, values.email);

                dispatch(verifyOTP({
                    otp: values.otp,
                    email: values.email,
                    multilingualMessage: t
                }))


            } else {
                const data1 = {
                    "email": values.email,
                    "language": store.globalreducer.language_email,
                    "multilingual": t
                }
                dispatch(authenticateEmailId(data1));
                dispatch(setemailAddress(values.email));
            }

            // ReactGA.event({
            //     category: "User Interaction",
            //     action: "sub_get_emailvalue",
            //     label: values.email
            //     // Name of the selected language
            // });
            logGAEvent("User Interaction", "sub_get_emailvalue", values.email, values.email);
        },
    })

    useEffect(() => {
        if (formik.values.otp === "" && snackBar.message !== "") {

        }
    }, [formik.values.otp]);



    // handle login with google 
    const handleGoogleClicked = () => {

        localStorage.setItem("isGoogle", 1)
        localStorage.setItem("language", language)
        const glanguage = localStorage.getItem("language")
        // ReactGA.event({
        //     category: "User Interaction",
        //     action: "sub_signup_google",
        //     label : "Redirect to signup with google"
        // });
        logGAEvent("User Interaction", "sub_signup_google_language", glanguage, emailAddress);

        logGAEvent("User Interaction", "sub_signup_google", emailAddress, emailAddress);

        window.location.href = `${Confdata.apiUrl}/SocialSSO/OauthurlServlet?ssotype=google&callbackurl=${Confdata.apiUrl}/jodostripe/subscription/${serviceID}&jodomoduleurl=`


    }

    // handle login with linkedIn
    const handleLinkedInClicked = () => {
        localStorage.setItem("isLinkedin", 1)
        localStorage.setItem("language", language)
        // window.location.href = `${Confdata.apiUrl}/SocialSSO/OauthurlServlet?ssotype=linkedin&callbackurl=${Confdata.apiUrl}/jodostripe/subscription/${serviceID}&jodomoduleurl=`
        // ReactGA.event({
        //     category: "User Interaction",
        //     action: "sub_signup_linkedIn",
        // });

        try {
            // ReactGA.event({
            //     category: "User Interaction",
            //     action: "sub_signup_linkedIn",
            //     label : "Redirect to signup with linkedin"
            // });
            logGAEvent("User Interaction", "sub_signup_linkedIn", emailAddress, emailAddress);

            // Redirect to LinkedIn SSO
            window.location.href = `${Confdata.apiUrl}/SocialSSO/OauthurlServlet?ssotype=linkedin&callbackurl=${Confdata.apiUrl}/jodostripe/subscription/${serviceID}&jodomoduleurl=`;
        } catch (error) {
            console.error("LinkedIn login failed:", error);
        }
    }

    // this function use to handle language selection 
    const handleLanguageChange = (event, name) => {
        const lang_code = event.target.value;
        const lang_email = languageObj.find(option => option.languagecode === lang_code).language;
        dispatch(setlanguage_email(lang_email))
        dispatch(setInitailLag(lang_code))
        localStorage.setItem("language", lang_code)
        dispatch(IntlActions.setLocale(lang_code))
        dispatch(setLanguage(lang_code));
        // ReactGA.event({
        //     category: "User Interaction",
        //     action: "sub_selected_language",
        //     label: lang_email, // Name of the selected language
        // });
        logGAEvent("User Interaction", "sub_selected_language", lang_code, emailAddress);

    }

    // this function will the resend otp send api 
    const handleResendOTP = () => {
        logGAEvent("User Interaction", "resend_OTP", formik.values.email, emailAddress);
        const datas = {
            "emailid": formik.values.email,
            "language": store.globalreducer.language_email,
            "multilingual": t
        }
        dispatch(setresendButtonDisable(true))
        dispatch(resendOTP(datas));
    }

    // if account is already created then redirect to sso page
    function RedirectToJodoToolbar(){
        window.location.href = `${Confdata.apiUrl}/jodotoolbar/`
    }


    //StripeEmailServlet return 103 then we redirect to sso 
    if (redirectingPage) {

        let message1 = `${emailAddress}` + " " + t('emailexist');
        let buttonMessage = t('signInTojodoToobar');
        return <DisplayMessage messageToDisplay={message1} errorPage="email-auth-page" messageToDisplayOnButton={buttonMessage} />

    } else {
        return (
            <div >
                {/* Navbar section start */}
                <div className="navbar">
                    <img src={jodoWorld} />
                    <a href="https://docs.jodoworld.com/index.php/docs/jodo-bpp-unified-toolbar/jodo-links-use-cases/" target={"_blank"}>
                        <Tooltip title={t('needhelp')}>
                            <img className="navbar-img1" src={supporticon} />
                        </Tooltip>
                    </a>
                </div>
                {/* Navbar section end */}

                {
                    // if otp is verify we to  move next page that means this will set true 
                    !moveToSubscriptionPage ?
                        <>
                            <form noValidate onSubmit={formik.handleSubmit}>
                                {
                                    // For language message
                                    newEmailVerified !== 1 && <Typography mt={'3rem'} textAlign={'center'} variant="heading">{t('selectlanguage')} </Typography>
                                }
                                <Grid container style={style.headcontainer} >
                                    {
                                        // It will show on OTP section
                                        showOTPmsgLabel &&
                                        <Box border={3} p={2} sx={style.head} style={style.box}>
                                            <Typography variant="heading" gutterBottom> {t('otpSendMessage')}</Typography>
                                            <Typography variant="subHeading">{t('secondotpSendMessage')}</Typography>
                                        </Box>
                                    }
                                    {
                                        // new email verification section 
                                        newEmailVerified !== 1 &&
                                        <>
                                            {/* For selectiong language */}
                                            <Grid className="language-selection">
                                                <Select
                                                    value={initailLag}
                                                    onChange={handleLanguageChange}
                                                    variant="standard"
                                                    className="menu"
                                                    MenuProps={{
                                                        PaperProps: { style: { maxHeight: 250 } },
                                                    }}>

                                                    {languageObj.map((option) => (
                                                        <MenuItem key={option.languagecode} value={option.languagecode}>
                                                            {option.language}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>

                                            <Typography className="type" variant='heading'>{t('selectsocialacc')}</Typography>
                                            {/* Sign in with Google */}
                                            <Button onClick={handleGoogleClicked} variant='customSecondary'>
                                                <Google />
                                                <Typography variant='subHeading' className="typosubHeadng">{t('signUpGoogle')}</Typography>
                                            </Button>
                                            {/* Sign in with linkedin */}
                                            {/* <Button onClick={handleLinkedInClicked} variant="customSecondary">
                                                <LinkedIn />
                                                <Typography variant='subHeading' className="typosubHeadng">{t('signUpLinkeIn')}</Typography>
                                            </Button>  */}

                                            <Typography variant='heading'>{t('or')}</Typography>
                                        </>
                                    }
                                    {/* Enter email input */}

                                    <TextField
                                        sx={style.email}
                                        id="email"
                                        name="email"
                                        label={t('emailAddress')}
                                        required oninvalid={t('tooltip_email')}
                                        value={formik.values.email}
                                        disabled={newEmailVerified === 1}
                                        onChange={(e) => {
                                            const sanitizedValue = DOMPurify.sanitize(e.target.value);
                                            formik.setFieldValue("email", sanitizedValue);
                                        }}
                                        error={formik.touched.email && Boolean(formik.errors.email)}
                                        helperText={formik.touched.email && formik.errors.email}
                                        inputProps={{ maxLength: 100 }}
                                        InputLabelProps={{
                                            sx: {
                                                '& .MuiFormLabel-asterisk': {
                                                    color: 'red',
                                                },
                                            },
                                            '&.MuiInputLabel-shrink': {
                                                fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                              },
                                              transition: 'all 0.2s ease', // Make it a bit bigger when focused
                                            
                                        }}
                                    />

                                    {/* when enter email and click OTP screen display */}
                                    {
                                        showOtpField && (
                                            <div style={{ position: "relative" }}>
                                                <TextField
                                                    sx={style.otp}
                                                    inputProps={{
                                                        maxLength: 6,
                                                        pattern: "\\d{6}",
                                                    }}
                                                    id="otp"
                                                    name="otp"
                                                    label={t("enterotp")}
                                                    required
                                                    title={t("tooltip_otp")}
                                                    value={formik.values.otp}
                                                    onChange={(e) => {
                                                        let sanitizedValue = DOMPurify.sanitize(e.target.value); // Sanitize input
                                                        sanitizedValue = sanitizedValue.replace(/[^0-9]/g, ""); // Keep only numbers
                                                        formik.setFieldValue("otp", sanitizedValue); // Update Formik state
                                                    }}
                                                    onInput={(event) => {
                                                        event.target.value = event.target.value.replace(/[^0-9]/g, ""); // Prevent invalid characters in UI
                                                    }}
                                                    error={formik.touched.otp && Boolean(formik.errors.otp)}
                                                    helperText={formik.touched.otp && formik.errors.otp}
                                                    InputLabelProps={{
                                                        sx: {
                                                            '& .MuiFormLabel-asterisk': {
                                                                color: 'red',
                                                            },
                                                        },
                                                        '&.MuiInputLabel-shrink': {
                                                            fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                                          },
                                                          transition: 'all 0.2s ease', // Make it a bit bigger when focused
                                                        
                                                    }}
                                              />
                                                {/* Call timer component for counting OTP Time */}
                                                <Timer />
                                            </div>
                                        )
                                    }


                                    <Grid className="resend-opt-grid">
                                        {/* For resend OTP */}
                                        {
                                            newEmailVerified === 1 &&
                                            <Button variant="customPrimary" type={"submit"} onClick={handleResendOTP}>
                                                {t('resendotp')}
                                            </Button>
                                        }
                                        <Button variant="customPrimary" type={"submit"}>
                                            {t('next')}
                                        </Button>

                                    </Grid>
                                        <span style={{color:"#256EFF", cursor:"pointer", fontWeight:"500", fontFamily:"sans-serif"}} onClick={RedirectToJodoToolbar}>{t('alreadyacccreated')}</span>
                                </Grid>
                                {
                                    openLoader && <Backdrop open={openLoader} childComponent={'loader'} />
                                }
                            </form>
                        </>
                        :
                        <SubscriptionPage route={'newUser'} />
                }

                <div className='footer'>
                    <a href="https://www.avhan.com" target={"_blank"}>
                        <Typography variant="footer">2018-23 © Avhan Technologies Pvt. Ltd.</Typography>
                    </a>
                </div>
            </div >
        )
    }
}

export default EmailAuthentication